import noop from 'lodash/noop';
import type { ProjectType } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { isSupportedEotmProjectType } from '@atlassian/jira-end-of-trial-common/src/utils.tsx';
import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';
import { ONE_DAY_IN_MILLISECONDS } from './constants.tsx';

const eotmLocalStorage = createLocalStorageProvider('end-of-trial-message');

export const hasViewedScreenWithin24Hours = (): boolean => {
	const lastViewed = eotmLocalStorage.get('lastViewedEOTMDate');

	if (!lastViewed) {
		return false;
	}

	const lastViewedDate = new Date(lastViewed);
	const now = new Date();

	return now.getTime() - lastViewedDate.getTime() < ONE_DAY_IN_MILLISECONDS;
};

export const updateLastViewedDate = (): void => {
	eotmLocalStorage.set('lastViewedEOTMDate', new Date().toISOString());
};

export const getEndOfTrialMessageExperiment = (projectType: ProjectType) => {
	if (!isSupportedEotmProjectType(projectType)) {
		return {
			isEnrolled: false,
			cohort: 'not-enrolled',
			fireStatsigExperimentExposure: noop,
		};
	}

	const [endOfTrialMessageConfig, fireStatsigExperimentExposure] = UNSAFE_noExposureExp(
		'end_of_trial_messaging_v2',
	);
	const cohort = endOfTrialMessageConfig.get('cohort', 'not-enrolled');

	return {
		isEnrolled: cohort !== 'not-enrolled',
		cohort,
		fireStatsigExperimentExposure,
		flagKey: 'end_of_trial_messaging_v2',
	};
};
